import { LinksRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class LinksService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new LinksRouteService());
	}

	findLinks(filter) {
		var url = this.routeService.findLinks(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	createLink(resource) {
		return this.apiClient.post(this.routeService.base, resource);
	}

	updateLink(resource) {
		return this.apiClient.put(this.routeService.base, resource);
	}

	deleteLink(id) {
		return this.apiClient.delete(this.routeService.base + id);
	}
}

export default LinksService;
